module.exports = __webpack_public_path__ + "fonts/ionicons.d535a25a.ttf";